import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-pageCW-map-modal__preview-content__itemWork"
}
const _hoisted_2 = { class: "m-pageCW-map-modal__preview-content__itemWork-category" }
const _hoisted_3 = {
  key: 0,
  class: "m-pageCW-map-modal__preview-content__itemWork-category-notification"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "m-pageCW-map-modal__preview-content__itemWork-head" }
const _hoisted_6 = { class: "m-pageCW-map-modal__preview-content__itemWork-number" }
const _hoisted_7 = { class: "m-pageCW-map-modal__preview-content__itemWork-address" }
const _hoisted_8 = { class: "m-pageCW-map-modal__preview-content__itemWork-description" }
const _hoisted_9 = { class: "m-pageCW-map-modal__preview-content__itemWork-date" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, " Дата начала ", -1 /* HOISTED */)
const _hoisted_11 = { class: "m-pageCW-map-modal__preview-content__itemWork-date-start" }
const _hoisted_12 = {
  key: 0,
  class: "m-pageCW-map-modal__preview-content__itemWork-date"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, " Дата завершения ", -1 /* HOISTED */)
const _hoisted_14 = { class: "m-pageCW-map-modal__preview-content__itemWork-date-end" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 1,
  class: "m-pageCW-map-modal__preview-content__itemIncident"
}
const _hoisted_17 = { class: "m-pageCW-map-modal__preview-content__itemIncident-category" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "m-pageCW-map-modal__preview-content__itemWork-head" }
const _hoisted_21 = { class: "m-pageCW-map-modal__preview-content__itemWork-number" }
const _hoisted_22 = { class: "m-pageCW-map-modal__preview-content__itemIncident-description" }
const _hoisted_23 = { class: "m-pageCW-map-modal__preview-content__itemIncident-date" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, " Дата начала ", -1 /* HOISTED */)
const _hoisted_25 = { class: "m-pageCW-map-modal__preview-content__itemWork-date-start" }
const _hoisted_26 = { class: "m-pageCW-map-modal__preview-content__itemIncident-date" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, " Дата завершения ", -1 /* HOISTED */)
const _hoisted_28 = { class: "m-pageCW-map-modal__preview-content__itemWork-date-end" }
const _hoisted_29 = { class: "m-pageCW-map-modal__preview-content__itemIncident-executor" }
const _hoisted_30 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (typeof _ctx.work.id === 'string')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.work.isRead)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            innerHTML: _ctx.categories[_ctx.work.category].svgContent
          }, null, 8 /* PROPS */, _hoisted_4),
          _createTextVNode(" " + _toDisplayString(_ctx.categories[_ctx.work.category].name), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, "№" + _toDisplayString(_ctx.work.number), 1 /* TEXT */),
          _createElementVNode("div", {
            class: "m-pageCW-map-modal__preview-content__itemWork-status",
            style: _normalizeStyle({backgroundColor: _ctx.statuses[_ctx.work.status].color})
          }, _toDisplayString(_ctx.statuses[_ctx.work.status].name), 5 /* TEXT, STYLE */)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(_ctx.work.address.name), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString(_ctx.work.address.subtitle), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.work.description), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_ctx.work.dateStart.isHideFromUsers)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.work.dateStart.dateStartForUser), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.work.dateStart.dateStart), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
          ])
        ]),
        (!_ctx.work.dateEnd.hasNoExactEndDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                (_ctx.work.dateEnd.isHideFromUsers)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.work.dateEnd.dateEndForUser), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.work.dateEnd.dateEnd), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("a", {
          href: `/construction-work/${_ctx.work.id}`,
          target: "_blank",
          class: "button button-primary button-xs"
        }, "Подробнее", 8 /* PROPS */, _hoisted_15)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.groupsIncidents[_ctx.work.groupId].svgContent)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: _ctx.groupsIncidents[_ctx.work.groupId].svgContent
              }, null, 8 /* PROPS */, _hoisted_18))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.groupsIncidents[_ctx.work.groupId].imgContent
              }, null, 8 /* PROPS */, _hoisted_19)),
          _createTextVNode(" " + _toDisplayString(_ctx.groupsIncidents[_ctx.work.groupId].name), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, "№" + _toDisplayString(_ctx.work.number), 1 /* TEXT */),
          _createElementVNode("div", {
            class: "m-pageCW-map-modal__preview-content__itemWork-status",
            style: _normalizeStyle({backgroundColor: '#'+_ctx.work.status.color})
          }, _toDisplayString(_ctx.work.status.title), 5 /* TEXT, STYLE */)
        ]),
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.work.description), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.work.dateBegin), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.work.dateEnd?.length ? _ctx.work.dateEnd : 'До устранения'), 1 /* TEXT */)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.work.executors, (executor) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(executor?.name) + " " + _toDisplayString(executor?.phones?.length ? _ctx.getStringPhones(executor?.phones) : ''), 1 /* TEXT */))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _createElementVNode("a", {
          href: _ctx.work.link,
          target: "_blank",
          class: "button button-primary button-xs"
        }, "Подробнее", 8 /* PROPS */, _hoisted_30)
      ]))
}